.c-notice {

    display: flex;

    align-items: center;

    padding: 1rem;

    border-radius: 0.5rem;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 500;

    cursor: default
}

  .c-notice p {

    font-size: 0.875rem;

    line-height: 1.25rem
}

  .c-notice a {

    font-weight: 600;

    text-decoration-line: underline
}

  .c-notice .icon3000 {

    min-height: 1rem;

    min-width: 1rem;

    margin-right: 0.5rem;

    margin-top: 2px;

    font-size: 1rem;

    line-height: 1.25rem
}

  .c-notice--notice {

    --tw-bg-opacity: 1;

    background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(29 78 216 / var(--tw-text-opacity, 1))
}

  .c-notice--notice a {

    --tw-text-opacity: 1;

    color: rgb(30 64 175 / var(--tw-text-opacity, 1))
}

  .c-notice--notice a:hover {

    --tw-text-opacity: 1;

    color: rgb(30 58 138 / var(--tw-text-opacity, 1))
}

  .c-notice--notice .icon3000 {

    --tw-text-opacity: 1;

    color: rgb(59 130 246 / var(--tw-text-opacity, 1))
}

  .c-notice--alert {

    --tw-bg-opacity: 1;

    background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(161 98 7 / var(--tw-text-opacity, 1))
}

  .c-notice--alert a {

    --tw-text-opacity: 1;

    color: rgb(133 77 14 / var(--tw-text-opacity, 1))
}

  .c-notice--alert a:hover {

    --tw-text-opacity: 1;

    color: rgb(113 63 18 / var(--tw-text-opacity, 1))
}

  .c-notice--alert .icon3000 {

    --tw-text-opacity: 1;

    color: rgb(234 179 8 / var(--tw-text-opacity, 1))
}

  .c-notice--error {

    --tw-bg-opacity: 1;

    background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(220 38 38 / var(--tw-text-opacity, 1))
}

  .c-notice--error a {

    --tw-text-opacity: 1;

    color: rgb(185 28 28 / var(--tw-text-opacity, 1))
}

  .c-notice--error a:hover {

    --tw-text-opacity: 1;

    color: rgb(153 27 27 / var(--tw-text-opacity, 1))
}

  .c-notice--error .icon3000 {

    --tw-text-opacity: 1;

    color: rgb(248 113 113 / var(--tw-text-opacity, 1))
}

  .c-notice--success {

    --tw-bg-opacity: 1;

    background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(21 128 61 / var(--tw-text-opacity, 1))
}

  .c-notice--success a {

    --tw-text-opacity: 1;

    color: rgb(21 128 61 / var(--tw-text-opacity, 1))
}

  .c-notice--success a:hover {

    --tw-text-opacity: 1;

    color: rgb(22 101 52 / var(--tw-text-opacity, 1))
}

  .c-notice--success .icon3000 {

    --tw-text-opacity: 1;

    color: rgb(74 222 128 / var(--tw-text-opacity, 1))
}

  .c-notice--neutral {

    --tw-bg-opacity: 1;

    background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(82 82 91 / var(--tw-text-opacity, 1))
}

  .c-notice--neutral a {

    --tw-text-opacity: 1;

    color: rgb(82 82 91 / var(--tw-text-opacity, 1))
}

  .c-notice--neutral a:hover {

    --tw-text-opacity: 1;

    color: rgb(63 63 70 / var(--tw-text-opacity, 1))
}

  .c-notice--neutral .icon3000 {

    --tw-text-opacity: 1;

    color: rgb(113 113 122 / var(--tw-text-opacity, 1))
}

/*# sourceMappingURL=data:application/json;base64,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 */